/*
 * action types
 */

const actions = {
  fetchPending: 'LOADING::SITES',
  fetchSites: 'FETCH::SITES',
  setSites: 'SET::SITES'
}

export const getSites = state => state.sites
export default actions

export const SET_EMPLOYER_ACTIVE_FILTER = 'SET_EMPLOYER_ACTIVE_FILTER'
export const SET_CONTRACTOR_ACTIVE_FILTER = 'SET_CONTRACTOR_ACTIVE_FILTER'

/*
 * other constants
 */

export const VisibilityFilters = {
  SHOW_ALL: 'SHOW_ALL',
  SHOW_ACTIVE: 'SHOW_ACTIVE'
}



// WEBPACK FOOTER //
// ./src/actions/index.jsx